module.exports = __webpack_public_path__ + "static/media/reportcard.d2be3f67.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/reportcard.png
 ** module id = 2713
 ** module chunks = 0
 **/